export const PARENTAL_RELATIONSHIP_OPTIONS = [
  {
    value: 'MOTHER',
    text: 'Mother',
  },
  {
    value: 'FATHER',
    text: 'Father',
  },
  {
    value: 'GUARDIAN',
    text: 'Guardian',
  },
];
